import React from "react";

function Stat({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 p-3">
      <div className="text-xs opacity-70">{label}</div>
      <div className="text-xl font-semibold">{value}</div>
      {hint && <div className="text-[11px] opacity-60">{hint}</div>}
    </div>
  );
}

export default function Home() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
      <div className="xl:col-span-2 grid grid-cols-1 md:grid-cols-3 gap-3">
        <Stat label="Active Users (24h)" value="1,284" hint="org-wide" />
        <Stat label="Pairing Success" value="93%" hint="last 24h" />
        <Stat label="Events / min" value="612" hint="symbolic" />
      </div>

      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Welcome</div>
        <div className="text-sm opacity-80">
          This is your Enterprise control surface. Use the left nav to manage devices, members, and privacy. Replace
          these mock stats with live Firestore/Functions when ready.
        </div>
      </div>

      {/* Tiny inline SVG chart (no third-party charts) */}
      <div className="xl:col-span-3 rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="text-base font-semibold mb-2">Readiness Trend (mock)</div>
        <svg className="w-full h-40" viewBox="0 0 600 160" preserveAspectRatio="none">
          <polyline
            points="0,120 60,110 120,105 180,95 240,100 300,92 360,85 420,95 480,88 540,82 600,78"
            fill="none"
            stroke="currentColor"
            className="opacity-80"
            strokeWidth="2"
          />
          <line x1="0" y1="120" x2="600" y2="120" stroke="currentColor" className="opacity-20" />
        </svg>
        <div className="text-xs opacity-60">Replace with org analytics from /realms/{`{realm}`}/orgs/{`{org}`}/analytics.</div>
      </div>
    </div>
  );
}
